<script>

import { mapActions, mapState } from 'vuex'
import { price } from '@/mixins/price'

export default {
  name: 'NewPaymentDocuments',
  mixins: [price],
  data () {
    return {
      is_loading: false,
      show_modal: false,
      selected: null
    }
  },
  watch: {
    show_modal (v) {
      if (v) {
        this.loadNewPaymentDocuments()
      }
    }
  },
  computed: {
    ...mapState('paymentDocumentStore', ['new_payments'])
  },
  methods: {
    ...mapActions('paymentDocumentStore', ['getNewPaymentDocuments']),
    selectItem (item) {
      this.selected = item
    },
    loadNewPaymentDocuments () {
      this.getNewPaymentDocuments()
    }
  },
  created () {
    this.loadNewPaymentDocuments()
  }
}
</script>

<template>
  <v-menu
      v-model="show_modal"
      left
      offset-y
      :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
          color="black"
          class="ml-2"
          v-bind="attrs"
          v-on="on"
          fab
          dark
          small
      >
        <v-badge
            :content="new_payments.length"
            :value="new_payments.length"
            color="red"
            overlap
        >
          <v-icon dark>
            mdi-cat
          </v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card width="400px">
      <v-card-title>Ожидают пополнения счета</v-card-title>
      <v-card-text class="px-0 py-0" style="max-height: 450px; overflow-y: auto" v-if="!is_loading">
        <v-list class="pt-0" three-line>
          <v-list-item
              v-for="item in new_payments"
              :key="item.id"
          >
            <v-list-item-content>
              <div><small>{{ item.created_at | moment('DD.MM.YYYY HH:mm') }}</small></div>
              <v-list-item-title>Пользователь: {{ item.user.name }}</v-list-item-title>
              <v-list-item-subtitle>Сумма: {{ formatPrice(item.amount) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-skeleton-loader
          v-else
          type="article"
      />
      <div class="text-center pb-6" v-if="!is_loading && new_payments.length === 0">
        Нет новых документов оплат
      </div>
      <v-card-actions v-if="new_payments.length">
        <v-btn
            width="100%"
            dark
            color="blue"
            @click="$router.push('/dashboard/drop-payment-documents')"
        >
          Перейти к документам
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<style scoped>

</style>
